import { useInterestQuestionnaires } from "PFCore/hooks/queries/common/use_interest_questionnaires";
import { Template } from "PFTypes";
import { useMemo } from "react";

export const useInterestQuestionariesTemplateConfiguration = (
  template: Pick<Template, "key"> | undefined
) => {
  const { data } = useInterestQuestionnaires();

  return useMemo(
    () => (data?.entries || []).find(({ templateKey }) => templateKey === template?.key),
    [template?.key, data]
  );
};
